import { ShortcutConfig } from "@/hooks/useKeyboardShortcut";

import { baseMenuShortcutConfig } from ".";

export const logoutShortcutConfig: ShortcutConfig = {
  ...baseMenuShortcutConfig,
  code: "KeyQ",
} as const;
